<template>
    <iframe :id="`inline-ex-${props.pagenum}`"
            :src="data.path"
            :style="data.styleRect"
            scrolling= "no"
            frameBorder="0"
            @load="iframeOnLoaded"
    ></iframe>
</template>

<script>
    import {ref, reactive, onMounted, onUnmounted, onUpdated, watchEffect, watch, computed, nextTick, toRaw}  from "vue";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePaging} from "@/modules/reader/book/paging";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useInlineExercise} from "@/modules/reader/inlineExercise/inlineExercise";
    import {appendUncached} from  "@/modules/utils/pathUtils";
    import config from "@/config/config.json";

    export default {
        props: {
            annot:Object,
            pagenum:Number,
        },
        setup(props, context) {
            const { pageState } = usePaging();
            const { pageResizeState } =  usePageResize();
            const { bookInfoState} = useBookInfo();
            const { getResizedAnnotationPos } = useAnnotationHelper();
            const { inlineExerciseState, saveAnswers } = useInlineExercise();

            const data = reactive({
                isActive:false,
                path:computed(()=>{
                    return `${bookInfoState.publicPath}/${props.annot.res}`;
                }),
                exerciseCode:computed(()=>{
                    return  data.path.split("/").slice(-2)[0];
                }),
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos)
                    }
                })

            });


            const borderSize = config.reader.inlineEx.borderSize;
            const containerWidth = config.reader.inlineEx.containerWidth;

            onUnmounted(()=>{
                window.removeEventListener("message", onMessageReceived);
                window.removeEventListener("resize",resizeInlineExercise);
                window.removeEventListener("orientationchange", resizeInlineExercise);
            })

            onMounted(()=>{
                //Listen to post message event from iframe. Note that the listener has to be placed here, not in iframeOnLoaded callback
                window.addEventListener("message", onMessageReceived);
            })

            const onMessageReceived = async(event)=>{

                if (event.data.from && event.data.from.indexOf(props.annot.res) >= 0) {

                    if (event.data.action === "saveTextbookEx") {
                        await saveAnswers({
                            exercisecode:data.exerciseCode,
                            content: event.data.content
                        }, props.pagenum)
                    } else if (event.data.action === "openReport") {
                        //inline exercise doesn't provide the correct callback get ebookcode from main iReader app... according to the url pattern, reformat the url:
                        let urlPieces = event.data.content.split("/");
                        urlPieces.splice(urlPieces.length -1, 0, localStorage.ebookcode);
                        let reportUrl = `${urlPieces.join("/")}?access_token=${localStorage.accessToken}}`;
                        reportUrl = appendUncached(reportUrl);
                        window.open(reportUrl);
                    }
                }
            }

            const iframeOnLoaded = (e) => {

                resizeInlineExercise();

                window.addEventListener("resize",resizeInlineExercise);
                window.addEventListener("orientationchange",(e)=>{
                    setTimeout(()=>{
                        resizeInlineExercise();
                    }, 200);
                });

                let origin = new URL(location.href).origin;
                let answer = "";

                if (inlineExerciseState.restoredEntireBookAnswers) {

                    for (let item of inlineExerciseState.restoredEntireBookAnswers) {
                        if (item.exercisecode === data.exerciseCode) {
                            answer = item.content;
                            break;
                        }
                    }

                }

                e.target.contentWindow.postMessage({
                    action: "_callback",
                    ret: answer,
                    usertype: (localStorage.role === "TCHR") ? "teacher" : "student"
                }, origin);


            }

            const resizeInlineExercise = ()=>{
                const iframeEl = document.getElementById(`inline-ex-${props.pagenum}`);
                let iframeDoc = iframeEl.contentDocument || iframeEl.contentWindow.document;
                let resizedDomPos = getResizedAnnotationPos(props.annot.domPos);
                let iframeRectWidth = parseFloat(resizedDomPos.width);
                let exBodyEl = iframeDoc.querySelector(".body_inline");
                exBodyEl.style.transform = `scale(${(iframeRectWidth - borderSize)/containerWidth})`
                exBodyEl.style.transformOrigin = "0 0";

            }

            watchEffect(()=>{

                nextTick(()=> {

                        setTimeout(()=> {
                            resizeInlineExercise();
                        }, 200);

                });
            })

            return {
                data,
                props,
                getResizedAnnotationPos,
                iframeOnLoaded
            }
        }
    }
</script>

<style scoped lang="scss">
    iframe {
        position:absolute;
        z-index:$zindex-inline-exercise;
    }
</style>